import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-list-of-row-policy',
  templateUrl: './list-of-row-policy.component.html',
  styleUrls: ['./list-of-row-policy.component.css']
})
export class ListOfRowPolicyComponent implements ICellRendererAngularComp {

  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return true;
  }

  toggleRow(rowData) {
    const rowDataMaster = this.params.context.componentParent.rowData;
    const rowIndex = this.params.rowIndex + 1;
    let index = rowIndex;
    while (rowDataMaster[index] && rowData.groupLevel !== rowDataMaster[index].groupLevel) {
      const element = rowDataMaster[index];
      element.isVisible = !element.isVisible;
      index++;
    }
    this.params.context.componentParent.rowData = rowDataMaster;
    this.params.api.onFilterChanged();
  }
}
